/* eslint-disable import/order */
import { DashboardBackgroundScripts } from '@jira/platform__layouts-background-scripts-layout/src/ui/dashboard/index.tsx';
import { DASHBOARD } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@jira/platform__common-constants/src/ssr-early-assets.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { dashboardWallboardRoute } from '@jira/router-routes__dashboard-routes/src/dashboardWallboardRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { dashboardWallboardEntryPoint } from '@jira/global-pages__dashboard-wallboard/src/dashboardWallboardEntryPoint.entrypoint.tsx';
import {
	dashboardResources,
	LazyForPaintBackgroundScripts,
	LazyForPaintConnectJsApi,
} from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const dashboardWallboardRouteEntry: Route = createEntry(dashboardWallboardRoute, () => ({
	group: 'dashboard',
	entryPoint: () => dashboardWallboardPageEntryPoint,

	layout: createLayout({
		globalComponents: [DashboardBackgroundScripts],
		// we don't want nav bar and right panel etc to appear in wallboard, so we use chromeless mode
		isChromeless: true,
	}),

	resources: [...jiraSpaResources(), ...dashboardResources()],

	forPaint: [LazyForPaintBackgroundScripts, LazyForPaintConnectJsApi],

	meta: {
		capability: DASHBOARD,
	},

	earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,
	wrmMode: 'early',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));

const dashboardWallboardPageEntryPoint = createChromelessEntryPoint({
	main: dashboardWallboardEntryPoint,
});
